module.exports = __webpack_public_path__ + "static/media/sidebar-student-mobile.b408d71d.jpg";